module.exports = __webpack_public_path__ + "img/3left-n-040a4b57.png";